module.exports = __webpack_public_path__ + "img/pic-5.8a970714.png";